export const SET_CART = "cart/SET_CART";
export const VALIDATE_CART = "cart/VALIDATE_CART";
